/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconTextColor = createReactComponent("outline", "text-color", "IconTextColor", [["path", { "d": "M9 15v-7a3 3 0 0 1 6 0v7", "key": "svg-0" }], ["path", { "d": "M9 11h6", "key": "svg-1" }], ["path", { "d": "M5 19h14", "key": "svg-2" }]]);

export { IconTextColor as default };
//# sourceMappingURL=IconTextColor.mjs.map
